<template>
    <v-expansion-panels v-model="expandedPanels" multiple accordion>
        <v-expansion-panel
            v-for="(building, index) in items"
            :key="`building-${index}`"
        >
            <v-expansion-panel-header
                class="py-1 px-2"
                disable-icon-rotate
                :hide-actions="index > 0"
            >
                <template v-slot:default>
                    <span>
                        <v-icon class="mr-2 rotate-icon" color="accent">{{
                            icons.arrowRight
                        }}</v-icon>
                        <v-icon class="mr-1 panel-header-icon">{{
                            icons[building.type]
                        }}</v-icon>
                        <span class="text-subtitle-1"
                            >{{ building.title }} ({{
                                deviceCount(building)
                            }})</span
                        >
                    </span>
                </template>
                <template v-slot:actions>
                    <v-btn text color="accent" @click.stop="onExpandAllClick">
                        <v-icon color="accent">{{ icons.expand }}</v-icon>
                        Expand All
                    </v-btn>
                    <v-btn text color="accent" @click.stop="onCollapseAllClick">
                        <v-icon color="accent">{{ icons.collapse }}</v-icon>
                        Collapse All
                    </v-btn>
                </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pl-10 pr-2">
                <building-view
                    :floors="building.floors"
                    @device-click="onDeviceClick"
                ></building-view>
            </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="!items.length">
            <v-expansion-panel-header hide-actions>
                <div class="no-data text-center text-body-1 font-weight-bold">
                    No data found...
                </div>
            </v-expansion-panel-header>
        </v-expansion-panel>
        <component
            :is="deviceDetailsComponent"
            :show-dialog="showDeviceDetailsDialog"
            :device-id="selectedDeviceId"
            @close-dialog="onCloseDeviceDetailsDialog"
        >
        </component>
    </v-expansion-panels>
</template>

<script>
import BuildingView from './components/BuildingView';
import DeviceDetailsDialog from '@/views/devices/components/DeviceDetailsDialog';

export default {
    name: 'TopologyView',
    components: {
        'building-view': BuildingView,
        'device-details-dialog': DeviceDetailsDialog
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            expandedPanels: [],
            deviceDetailsComponent: '',
            selectedDeviceId: '',
            showDeviceDetailsDialog: false
        };
    },
    watch: {
        items: {
            immediate: true,
            handler(value) {
                let expanded = [];
                if (value.length) {
                    expanded = [...Array(value.length).keys()];
                }
                this.$nextTick(() => {
                    this.expandedPanels = expanded;
                });
            }
        }
    },
    methods: {
        onExpandAllClick() {
            if (this.items.length) {
                this.$nextTick(() => {
                    this.expandedPanels = [...Array(this.items.length).keys()];
                });
            }
        },
        onCollapseAllClick() {
            this.$nextTick(() => {
                this.expandedPanels = [];
            });
        },
        onDeviceClick(item) {
            this.openDeviceDialog(item);
        },
        onCloseDeviceDetailsDialog() {
            this.deviceDetailsComponent = '';
            this.showDeviceDetailsDialog = false;
            this.selectedDeviceId = '';
        },
        // ======================= Others ======================
        openDeviceDialog(device) {
            if (device && device.id) {
                this.deviceDetailsComponent = 'device-details-dialog';
                this.selectedDeviceId = device.id;
                this.showDeviceDetailsDialog = true;
            }
        },
        deviceCount(building) {
            if (building && building.floors.length) {
                return building.floors.reduce((floorSum, floor) => {
                    return (
                        floorSum +
                        floor.rooms.reduce((roomSum, room) => {
                            let deviceCount = 0;
                            if (
                                room &&
                                room.serviceAccount &&
                                room.serviceAccount.devices
                            ) {
                                deviceCount =
                                    room.serviceAccount.devices.length;
                            }
                            return roomSum + deviceCount;
                        }, 0)
                    );
                }, 0);
            }
            return 0;
        }
    }
};
</script>

<style lang="scss" scoped>
.v-expansion-panel {
    :before,
    :after {
        box-shadow: 0 0 !important;
        border: 0 !important;
    }
}
.v-expansion-panel-header,
.v-expansion-panel-header--active {
    min-height: 48px !important;
}
.v-expansion-panel-header--active {
    .rotate-icon {
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
    }
}
::v-deep .panel-header-icon {
    vertical-align: middle;
}
::v-deep .v-expansion-panel-content__wrap {
    padding: 0 !important;
}
.theme--dark .no-data {
    color: map-get(map-get($material-dark, 'text'), 'disabled') !important;
}
.theme--light .no-data {
    color: map-get(map-get($material-light, 'text'), 'disabled') !important;
}
</style>
